import React, {useState} from 'react';
import {Spring} from 'react-spring/renderprops';
import styled from 'styled-components';
import { useHistory } from "react-router-dom";
import Popover, { ArrowContainer }  from 'react-tiny-popover'
import theme from "../../../Theme/Theme";
import PopoverInner from "./../PopoverInner";

const StyledG = styled.g`
  cursor: pointer;
`;


export default function ExperienceLayersSvg(props) {
  const [hover, setHover] = useState(null);
  const data = props.data;
  let history = useHistory();
  return (
      <svg width="100%" height="100%" viewBox="-15 -15 542 542" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
          {/* Generator: Sketch 59.1 (86144) - https://sketch.com */}
          {/*<title>E4H/Onion</title>*/}
        <desc>Created with Sketch.</desc>
        <g  stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <StyledG id="Society"
             onMouseEnter={ () => setHover(data[2].name)}
             onMouseLeave={ () => setHover(null)}
             onFocus={() => setHover(data[2].name)}
             onBlur={ () => setHover(null) }
             role={'link'}
             tabIndex={0}
             onClick={ () => history.push(`/activities?experience=${data[2].name}`)}
          >
            <Spring
              from={{ r: 256 }}
              to={{ r: hover === data[2].name ? 256 + 15 : 256 }}>
              {props => (
                <circle
                  fill={data[2].color}
                  cx={256}
                  cy={256}
                  r={ props.r }
                />
              )}
            </Spring>
            <Popover
              isOpen={hover === data[2].name }

              // isOpen={true}
              position={'left'} // preferred position
              content={({ position, targetRect, popoverRect }) => (
                <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                  position={position}
                  targetRect={targetRect}
                  popoverRect={popoverRect}
                  arrowColor={'white'}
                  arrowSize={10}
                  arrowStyle={{ pointerEvents: 'none' }}
                >
                  <PopoverInner
                    data={data[2]}
                  />
                </ArrowContainer>
              )}
            >
            <text fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#FFFFFF">
              <tspan x="232.5" y={489}>{props.data[2].name}</tspan>
            </text>
            </Popover>
          </StyledG>
          <StyledG
            id="Community-partner"
            transform="translate(45.000000, 24.000000)"
            onMouseEnter={ () => setHover(data[1].name)}
            onMouseLeave={ () => setHover(null)}
            onFocus={() => setHover(data[1].name)}
            onBlur={ () => setHover(null) }
            role={'link'}
            tabIndex={0}
            onClick={ () => history.push(`/activities?experience=${data[1].name}`)}
          >
            <Spring
              from={{ r: 211.5 }}
              to={{ r: hover === data[1].name ? 211.5 + 15 : 211.5 }}>
              {props => (
                <circle
                  fill={data[1].color}
                  cx="211.5"
                  cy="211.5"
                  r={ props.r }
                />
              )}
            </Spring>
            <Popover
              isOpen={hover === data[1].name }

              // isOpen={true}
              position={'left'} // preferred position
              content={({ position, targetRect, popoverRect }) => (
                <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                  position={position}
                  targetRect={targetRect}
                  popoverRect={popoverRect}
                  arrowColor={'white'}
                  arrowSize={10}
                  arrowStyle={{ pointerEvents: 'none' }}
                >
                  <PopoverInner
                    data={data[1]}
                  />
                </ArrowContainer>
              )}
            >
            <text fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#FFFFFF">
              <tspan x={148} y={397}>{props.data[1].name}</tspan>
            </text>
            </Popover>
          </StyledG>
            <StyledG
              id="Class-Team-Student"
              onMouseEnter={ () => setHover(data[0].name)}
              onMouseLeave={ () => setHover(null)}
              onFocus={() => setHover(data[0].name)}
              onBlur={ () => setHover(null) }
              role={'link'}
              tabIndex={0}
              onClick={ () => history.push(`/activities?experience=${data[0].name}`)}
            >
              <g id="Class" transform="translate(87.000000, 46.000000)">
                <Spring
                  from={{ r: 169 }}
                  to={{ r: hover === data[0].name ? 169 + 15 : 169 }}>
                  {props => (
                    <circle
                      fill={'white'}
                      cx={169}
                      cy={169}
                      r={ props.r }
                    />
                  )}
                </Spring>
                <Spring
                  from={{ r: 169 }}
                  to={{ r: hover === data[0].name ? 169 + 15 : 169 }}>
                  {props => (
                    <circle
                      fill={ data[0].color }
                      opacity={.8}
                      cx={169}
                      cy={169}
                      r={ props.r }
                    />
                  )}
                </Spring>
                <text fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#FFFFFF">
                  <tspan x="151.5" y={316}>{props.data[0].name.split(', ')[2]}</tspan>
                </text>
              </g>
              <g id="Team" transform="translate(131.000000, 78.000000)">
                <Spring
                  from={{ r: 125 }}
                  to={{ r: hover === data[0].name ? 125 + 15 : 125 }}
                  delay={100}
                >
                  {props => (
                    <circle
                      fill={ data[0].color }
                      opacity={.4}
                      cx={125}
                      cy={125}
                      r={ props.r }
                    />
                  )}
                </Spring>
                <Popover
                  isOpen={hover === data[0].name }

                  // isOpen={true}
                  position={'left'} // preferred position
                  content={({ position, targetRect, popoverRect }) => (
                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                      position={position}
                      targetRect={targetRect}
                      popoverRect={popoverRect}
                      arrowColor={'white'}
                      arrowSize={10}
                      arrowStyle={{ pointerEvents: 'none' }}
                    >
                      <PopoverInner
                        data={data[0]}
                      />
                    </ArrowContainer>
                  )}
                >
                <text fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#FFFFFF">
                  <tspan x="106.5" y={220}>{props.data[0].name.split(', ')[1]}</tspan>
                </text>
                </Popover>
              </g>
              <g id="Student" transform="translate(176.000000, 96.000000)">
                <Spring
                  from={{ r: 80 }}
                  to={{ r: hover === data[0].name ? 80 + 15 : 80 }}
                  delay={250}
                >
                  {props => (
                    <circle
                      fill={ data[0].color }
                      opacity={.5}
                      cx={80}
                      cy={80}
                      r={ props.r }
                    />
                  )}
                </Spring>
                <text fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#FFFFFF">
                  <tspan x="53.5" y={126}>{props.data[0].name.split(', ')[0]}</tspan>
                </text>
              </g>
            </StyledG>
        </g>
      </svg>
  );
}
